import React from 'react';
import clearSkyDayIcon from './assets/01d@2x.png';
import clearSkyNightIcon from './assets/01n@2x.png';
import fewCloudsDayIcon from './assets/02d@2x.png';
import fewCloudsNightIcon from './assets/02n@2x.png';
import scatteredCloudDayIcon from './assets/03d@2x.png';
import scatteredCloudNightIcon from './assets/03n@2x.png';
import brokenCloudsDayIcon from './assets/04d@2x.png';
import brokenCloudsNightIcon from './assets/04n@2x.png';
import showerRainDayIcon from './assets/09d@2x.png';
import showerRainNightIcon from './assets/09n@2x.png';
import rainDayIcon from './assets/10d@2x.png';
import rainNightIcon from './assets/10n@2x.png';
import thunderstormDayIcon from './assets/11d@2x.png';
import thunderstormNightIcon from './assets/11n@2x.png';
import snowDayIcon from './assets/13d@2x.png';
import snowNightIcon from './assets/13n@2x.png';
import mistDayIcon from './assets/50d@2x.png';
import mistNightIcon from './assets/50n@2x.png';
import ErrorComponent from '../ErrorComponent/ErrorComponent';
import ErrorText from '../ErrorComponent/ErrorText';
import HelpIcon from '@material-ui/icons/Help';

type WeatherIconProps = {
	icon: string;
	description: string;
};

export default function WeatherIcon({ description, icon }: WeatherIconProps) {
	const getIcon = (iconType: string) => {
		switch (iconType) {
			case '01d':
				return clearSkyDayIcon;
			case '01n':
				return clearSkyNightIcon;
			case '02d':
				return fewCloudsDayIcon;
			case '02n':
				return fewCloudsNightIcon;
			case '03d':
				return scatteredCloudDayIcon;
			case '03n':
				return scatteredCloudNightIcon;
			case '04d':
				return brokenCloudsDayIcon;
			case '04n':
				return brokenCloudsNightIcon;
			case '09d':
				return showerRainDayIcon;
			case '09n':
				return showerRainNightIcon;
			case '10d':
				return rainDayIcon;
			case '10n':
				return rainNightIcon;
			case '11d':
				return thunderstormDayIcon;
			case '11n':
				return thunderstormNightIcon;
			case '13d':
				return snowDayIcon;
			case '13n':
				return snowNightIcon;
			case '50d':
				return mistDayIcon;
			case '50n':
				return mistNightIcon;
			default:
				return null;
		}
	};

	const showWeatherIcon = !!getIcon(icon);

	try {
		return (
			<ErrorComponent Children message='Icon cannot be rendered'>
				<div style={{ height: '100px', minWidth: '100px' }}>
					<div style={{ paddingTop: showWeatherIcon ? '12px' : '0' }}>
						{showWeatherIcon ? (
							<img
								src={getIcon(icon)}
								alt={description}
								width='55%'
								style={{
									display: 'block',
									margin: '0 auto',
									backgroundColor: '#ccc',
									borderRadius: '50%',
									maxWidth: '60px',
								}}
							/>
						) : (
							<HelpIcon
								style={{
									color: '#3c4858',
									width: '60px',
									height: '60px',
									display: 'block',
									margin: '0 auto',
								}}
							/>
						)}
					</div>
					<div style={{ marginTop: '4px', color: '#3c4858', textAlign: 'center' }}>
						{description}
					</div>
				</div>
			</ErrorComponent>
		);
	} catch (error) {
		return <ErrorText message='Icon cannot be rendered' />;
	}
}
